import axios from 'axios';
import { haversine } from '../../util/haversine';

export const START_GET_COMMUNITIES = 'START_GET_COMMUNITIES';
export const END_GET_COMMUNINITIES = 'END_GET_COMMUNINITIES';

const startGetCommunities = () => {
  return {
    type: START_GET_COMMUNITIES
  };
};

const endGetCommunities = (params, response) => {
  return {
    type: END_GET_COMMUNINITIES,
    params,
    response
  };
};

const getCommunities = (params) => {
  let reqParams = {
    minPrice: params.minPrice,
    maxPrice: params.maxPrice,
    bedrooms: params.bedrooms,
    bathrooms: params.bathrooms,
    minSquareFeet: params.minSquareFeet,
    maxSquareFeet: params.maxSquareFeet,
    startIndex: params.startIndex,
    latitude: params.centerLat,
    longitude: params.centerLng,
    swLat: params.swLat,
    swLng: params.swLng,
    neLat: params.neLat,
    neLng: params.neLng,
    radius: Math.ceil(haversine(params.centerLat, params.centerLng, params.swLat, params.swLng, 'mile')),
    resultType: params.resultType,
    initState: params.initState,
    sortBy: params.sortBy,
    sortAsc: params.asc,
    mapShown: params.mapShown,
    pageNumber: 0,
    seed: params.seed,
  };


  if (params.homeTypes) reqParams.homeTypes = params.homeTypes;
  if (params.bays) reqParams.bays = params.bays;
  if (params.floors) reqParams.floors = params.floors;
  if (params.brand) reqParams.brand = params.brand;
  if (params.quickMoveIn) reqParams.quickMoveIn = params.quickMoveIn;
  if (params.metro) reqParams.metro = params.metro;
  if (params.city) reqParams.city = params.city;
  if (params.mpCommunitiesOnly) reqParams.mpCommunitiesOnly = params.mpCommunitiesOnly;
  if (params.guestCommunityIds) {
    reqParams.guestCommunityIds = params.guestCommunityIds.join(',');
  }

  return (dispatch) => {
    dispatch(startGetCommunities());
    axios({
      method: 'GET',
      url: `/api/search/findcommunities?${Object.keys(reqParams)
        .reduce((a, k) => {
          a.push(k + '=' + encodeURIComponent(reqParams[k]));
          return a;
        }, [])
        .join('&')}`
    }).then((response) => {
      dispatch(endGetCommunities(params, response))
    });
  };
};

export { getCommunities, startGetCommunities };
